export type ValidationErrorsConfig = {
  sr: {
    REQUIRED: string;
    EMAIL: string;
    PREFIX_MATCH: string;
    MSISDN_MATCH: string;
    JUST_NUMBERS: string;
    ACCEPT_CONDITIONS: string;
    MSIDN_MIN: string;
    MSIDN_MAX: string;
  };
  en: {
    REQUIRED: string;
    EMAIL: string;
    PREFIX_MATCH: string;
    MSISDN_MATCH: string;
    JUST_NUMBERS: string;
    ACCEPT_CONDITIONS: string;
    MSIDN_MIN: string;
    MSIDN_MAX: string;
  };
};

export const ValidationErrors: ValidationErrorsConfig & {
  [key: string]: { [key: string]: string };
} = {
  sr: {
    REQUIRED: 'Obavezno polje',
    EMAIL: 'E-mail nije u odgovarajućem formatu',
    PREFIX_MATCH: 'Prefiks za broj se ne poklapa sa prethodno unetim',
    MSISDN_MATCH: 'Ovaj broj se ne poklapa sa prethodno unetim',
    JUST_NUMBERS: 'Broj telefona treba da sadrži samo cifre',
    ACCEPT_CONDITIONS: 'Prihvatite uslove',
    MSIDN_MIN: 'Broj telefona mora biti najmanje % karaktera',
    MSIDN_MAX: 'Broj telefona ne sme biti duži od % karaktera',
  },
  en: {
    REQUIRED: 'Required field',
    EMAIL: 'The email is not in the correct format',
    PREFIX_MATCH: 'The prefix for the number does not match the one previously entered',
    MSISDN_MATCH: 'This number does not match the one previously entered',
    JUST_NUMBERS: 'The phone number should contain only digits',
    ACCEPT_CONDITIONS: 'Accept the terms',
    MSIDN_MIN: 'The phone number must be at least % characters',
    MSIDN_MAX: 'The phone number must not be longer than % characters',
  },
};

export default ValidationErrors;
